import { toFiniteNumber } from "@/common/helpers/toFiniteNumber";
import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";

export type CapacityShortfallRate = Pick<RateData, "isGroup" | "isScheduled" | "salesEndMode"> & {
  seats: RateData["seats"] | string;
  attendeesByTicket: RateData["attendeesByTicket"] | string;
  salesEndDate: Date | string | null | undefined;
};

export interface CapacityShortfall {
  overallSeats: number;
  sellableTotal: number;
}

export const getCapacityShortfall = (
  overallSeats: string | undefined,
  rates: CapacityShortfallRate[] | undefined,
  now: Date
): CapacityShortfall | null => {
  const overall = toFiniteNumber(overallSeats);
  if (overall === null || overall < 0) {
    return null;
  }

  const sellableTotal = (rates ?? []).reduce((total, rate) => {
    const seats = toFiniteNumber(rate.seats);
    if (seats === null || seats <= 0) {
      return total;
    }
    const hasEnded =
      rate.isScheduled &&
      rate.salesEndMode === "customDate" &&
      Boolean(rate.salesEndDate) &&
      new Date(rate.salesEndDate as Date).getTime() <= now.getTime();
    if (hasEnded) {
      return total;
    }
    const attendeesMultiplier = (rate.isGroup ? toFiniteNumber(rate.attendeesByTicket) : null) || 1;
    return total + seats * attendeesMultiplier;
  }, 0);

  if (sellableTotal <= overall) {
    return null;
  }

  return { overallSeats: overall, sellableTotal };
};
